import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';

import { environment } from '../../environments/environment';
import { MeResponse } from './api.types';

@Injectable({ providedIn: 'root' })
export class MeService {
  private me$?: Observable<MeResponse>;

  constructor(private readonly http: HttpClient) { }

  getMe(forceRefresh = false): Observable<MeResponse> {
    if (!this.me$ || forceRefresh) {
      this.me$ = this.http
        .get<MeResponse>(`${environment.api.baseUrl}/v1/me`)
        .pipe(shareReplay({ bufferSize: 1, refCount: true }));
    }

    return this.me$;
  }
}
